import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthProvider";
import ClientProvider from "./react-query";
import "normalize.css";

ReactDOM.render(
  <ClientProvider>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </ClientProvider>,
  document.getElementById("root")
);
